import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: ${props => (props.isList ? 'column' : 'row')};
  align-items: ${props => (props.isList ? 'flex-start' : 'center')};
  gap: ${props => (props.isList ? props.theme.spacing.sp8 : props.theme.spacing.sp4)};
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const Attachment = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
